module.exports = __webpack_public_path__ + "static/img/banner-carousel-20251211-154026.78c6a60.png";